/**
 * useCreatives Hook
 * Хук для работы с креативами
 */

import { useState, useEffect, useCallback } from 'react';
import { creativesService } from '../services/creatives';

export const useCreatives = () => {
  const [creatives, setCreatives] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCreatives = useCallback(async (params = {}) => {
    try {
      setLoading(true);
      setError(null);
      const data = await creativesService.getAll(params);
      setCreatives(data);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      console.error('Error fetching creatives:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCreatives();
  }, [fetchCreatives]);

  const createCreative = async (data) => {
    try {
      setLoading(true);
      const result = await creativesService.create(data);
      await fetchCreatives();
      return result;
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateCreative = async (erid, data) => {
    try {
      setLoading(true);
      const result = await creativesService.update(erid, data);
      await fetchCreatives();
      return result;
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteCreative = async (erid) => {
    try {
      setLoading(true);
      await creativesService.delete(erid);
      await fetchCreatives();
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const syncCreatives = async () => {
    try {
      setLoading(true);
      const result = await creativesService.sync();
      await fetchCreatives();
      return result;
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    creatives,
    loading,
    error,
    createCreative,
    updateCreative,
    deleteCreative,
    syncCreatives,
    refresh: fetchCreatives
  };
};
